import * as yup from 'yup';
import { REX_ADMIN_PASSWORD_REG, REX_PHONE, REX_USER_EMAIL_PATTERN, REX_USER_NAME_TEXT } from '../../../../../lib/rex';

export const errorMessages = {
  REQUIRE_MESSAGE: '필수 정보입니다.',
  EMAIL_INVALID: '유효한 이메일을 입력해주세요.',
  EMAIL_MAX_LENGTH: '이메일은 최대 100자까지 입력 가능합니다.',
  USER_NAME_MIN_LENGTH: '이름은 최소 2자 이상이어야 합니다.',
  USER_NAME_MAX_LENGTH: '이름은 최대 20자까지 입력 가능합니다.',
  USER_NAME_INVALID: '이름은 한글, 영문만 사용 가능하며, 특수문자는 허용되지 않습니다.',
  PHONE_INVALID: '유효한 핸드폰 번호를 입력해주세요. (예: 010-0000-0000)',
  PASSWORD_REQUIRED: '비밀번호는 필수입니다.',
  PASSWORD_MIN_LENGTH: '비밀번호는 최소 6자 이상이어야 합니다.',
  PASSWORD_MAX_LENGTH: '비밀번호는 최대 20자까지 가능합니다.',
  PASSWORD_INVALID: '비밀번호는 영문, 숫자, 특수문자 포함 최소 6자, 최대 20자이어야 합니다.',
  PASSWORD_CONFIRM_NOT_MATCH: '비밀번호가 일치하지 않습니다.',
};

export const createFormValidationSchema = yup.object().shape({
  email: yup
    .string()
    .required(errorMessages.REQUIRE_MESSAGE)
    .max(100, errorMessages.EMAIL_MAX_LENGTH)
    .matches(REX_USER_EMAIL_PATTERN, errorMessages.EMAIL_INVALID),
  name: yup
    .string()
    .required(errorMessages.REQUIRE_MESSAGE)
    .min(2, errorMessages.USER_NAME_MIN_LENGTH)
    .max(20, errorMessages.USER_NAME_MAX_LENGTH)
    .matches(REX_USER_NAME_TEXT, errorMessages.USER_NAME_INVALID),
  phone: yup.string().required(errorMessages.REQUIRE_MESSAGE).matches(REX_PHONE, errorMessages.PHONE_INVALID),
  password: yup
    .string()
    .required(errorMessages.REQUIRE_MESSAGE)
    .min(6, errorMessages.PASSWORD_MIN_LENGTH)
    .max(20, errorMessages.PASSWORD_MAX_LENGTH)
    .matches(REX_ADMIN_PASSWORD_REG, errorMessages.PASSWORD_INVALID),
  passwordConfirm: yup
    .string()
    .required(errorMessages.REQUIRE_MESSAGE)
    .test('passwords-match', errorMessages.PASSWORD_CONFIRM_NOT_MATCH, function (value) {
      return this.parent.password === value;
    }),
  level: yup.number().required(),
  status: yup.string().required(),
  permission: yup.object().required(),
});

export const editFormValidationSchema = yup.object().shape({
  name: yup
    .string()
    .required(errorMessages.REQUIRE_MESSAGE)
    .min(2, errorMessages.USER_NAME_MIN_LENGTH)
    .max(20, errorMessages.USER_NAME_MAX_LENGTH)
    .matches(REX_USER_NAME_TEXT, errorMessages.USER_NAME_INVALID),
  password: yup
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .min(6, errorMessages.PASSWORD_MIN_LENGTH)
    .max(20, errorMessages.PASSWORD_MAX_LENGTH)
    .matches(REX_ADMIN_PASSWORD_REG, errorMessages.PASSWORD_INVALID),
  passwordConfirm: yup
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .test('passwords-match', errorMessages.PASSWORD_CONFIRM_NOT_MATCH, function (value) {
      return this.parent.password === value;
    }),
  level: yup.number().required(),
  status: yup.string().required(),
  permission: yup.object().required(),
});
